module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074cb_banner_800x600.97e6dc6e.png";